import React, { useState, Fragment } from "react";
import './Followup.css';
import { nanoid } from "nanoid";
import data from "./mock-data.json";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableRow";
const Followup=()=>{
    const [contacts, setContacts] = useState(data);
  const [addFormData, setAddFormData] = useState({
    Date: "",
    description: ""
    
  });
  const [editFormData, setEditFormData] = useState({
    Date: "",
    description: ""
  });
  const [editContactId, setEditContactId] = useState(null);

  const handleAddFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;

    setAddFormData(newFormData);
  };
  const handleEditFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);
  };
  const handleAddFormSubmit = (event) => {
    event.preventDefault();
    const newContact = {
        id: nanoid(),
        Date: addFormData.Date,
        description: addFormData.description
       
      };
  
      const newContacts = [...contacts, newContact];
    
      setContacts(newContacts);
    };
    const handleEditFormSubmit = (event) => {
        event.preventDefault();
    
        const editedContact = {
          id: editContactId,
          Date: editFormData.Date,
          description: editFormData.description
         
        };
    
        const newContacts = [...contacts];
    
        const index = contacts.findIndex((contact) => contact.id === editContactId);
    
        newContacts[index] = editedContact;
    
        setContacts(newContacts);
        setEditContactId(null);
      };
      const handleEditClick = (event, contact) => {
        event.preventDefault();
        setEditContactId(contact.id);
    
        const formValues = {
          Date: contact.Date,
          description: contact.description
         
        };
    
        setEditFormData(formValues);
      };
    
      const handleCancelClick = () => {
        setEditContactId(null);
      };
      const handleDeleteClick = (contactId) => {
        const newContacts = [...contacts];
    
        const index = contacts.findIndex((contact) => contact.id === contactId);
    
        newContacts.splice(index, 1);
    
        setContacts(newContacts);
      };
    return(<div className="Followup ">
              <div className="container-fluid1 py-2 icueTopBarContainer bg-white">
                 <div className="row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                       <div className="topBarLfContainer d-flex">
                           <div className="icueLogoContainer">
                                <img src="images/logo.png" alt="ICue Logo" className="icueLogo" />
                            </div>
                                    <div className="icueSearchBox w-75 mx-3">
                                         <div className="input-group ">
                                            <span className="input-group-text" id="basic-addon1">
                                              <i className="bi bi-search"></i>
                                             </span>
                                      <input type="search" id="text-search" className="form-control icueSearchBoxControl" placeholder="Enter keywords..." aria-label="Username" aria-describedby="basic-addon1"/>
                                         </div>
                                     </div> 
                        </div>
                   </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="d-flex flex-row-reverse">
                    <div className="icueProfile px-2">
                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" />
                    </div>
                    <div className="position-relative px-2">
                        <a href="#!" id="icueNotifyBoxHandler">
                            <i className="bi bi-bell">
                                <span className="position-absolute icueNofIndic"></span>
                            </i>
                        </a>
                        <div className="icueNotifyBox" id="icueNotifyBox">
                            Notifications
                        </div>
                    </div>

                    <div className="icueUserName fs-6 px-2">
                        Viral Patel
                    </div>

                    <div className=" icueMail px-2">
                        <i className="bi bi-headset"></i> &nbsp;
                        adminhelpdesk@gmail.com
                    </div>
                </div>
            </div>
        </div>
    </div>
   
   
    <div className="container-fluid my-2">
        <div className="row">
            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 bg-white">
                <div className="icueRespSideBar d-xxl-none d-xl-none d-lg-none d-md-block d-sm-block d-block" id="icueRespSideBar">
                    <button type="button" className="btn btn-primary" id="icueRespHumburger">
                        <i className="bi bi-grid-3x3-gap" id="icueOpenIcon"></i>
                        <i className="bi bi-x-lg" id="icueCloseIcon"></i>
                    </button>
                    <div className="icueSideBar" id="icueSideBar">
                        <nav className="navbar icueSideNavContainer">
                            <ul className="icueNavBarList">
                                <li className="icueNavBarItem active">
                                    <a href="/AgentDashboard" className="icueNavBarLink" id="">Dashboard</a>
                                </li>

                                <li className="icueNavBarItem border-bottom-0">
                                    <a href="#!" className="icueNavBarLink" id="">LMS</a>
                                </li>

                                <li>
                                    <ul className="icueSubNavBar">
                                        <li className="icueSubNavItem">
                                            <a href="/AgentLMS" className="icueSubNavLink  text-capitalize">All Leads</a>
                                        </li>
                                    </ul>
                                </li>
                                <hr></hr>
                                <li className="icueNavBarItem border-bottom-0">
                                    <a href="#!" className="icueNavBarLink" id="">Settings</a>
                                </li>
                                <li>
                                    <ul className="icueSubNavBar">
                                        <li className="icueSubNavItem">
                                            <a href="#!" className="icueSubNavLink  text-capitalize">Change Password</a>
                                        </li>
                                        <li className="icueSubNavItem">
                                            <a href="#!" className="icueSubNavLink  text-capitalize">Profile</a>
                                        </li>
                                    </ul>
                                </li>
                                <hr></hr>
                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="icueNavSideBar d-xxl-block d-xl-block d-lg-block d-md-none d-sm-none d-none" id="icueNavSideBar">
                    <nav>
                        <ul className="icueNavBarList">
                            <li className="icueNavBarItem active">
                                <a href="/AgentDashboard" className="icueNavBarLink" id="">Dashboard</a>
                            </li>

                            <li className="icueNavBarItem border-bottom-0">
                                <a href="#!" className="icueNavBarLink" id="">LMS</a>
                            </li>

                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem" style={{marginTop:"-0.75rem"}}>
                                        <a href="/AgentLMS" className="icueSubNavLink  text-capitalize">All Leads</a>
                                    </li>
                                </ul>
                            </li>
                            <hr></hr>
                            <li className="icueNavBarItem border-bottom-0" style={{marginTop:"-0.625rem"}}>
                                <a href="#!" className="icueNavBarLink" id="">Settings</a>
                            </li>
                            <li>
                                <ul className="icueSubNavBar" style={{marginTop:"-0.75rem"}}>
                                    <li className="icueSubNavItem">
                                        <a href="#!" className="icueSubNavLink  text-capitalize">Change Password</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="#!" className="icueSubNavLink  text-capitalize">Profile</a>
                                    </li>
                                </ul>
                            </li>
                            <hr></hr>
                        </ul>
                    </nav>
                </div>
            
            </div>
            <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 ">
                <main className="mainBodyContainer">
                    <div className="row my-2">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-2 px-3">
                            <div className="d-flex justify-content-between">
                                <h4 className="text-capitalize" style={{fontFamily:"ErasDemiITC", marginLeft:"12px"}}>Follow up</h4>
                                <div className="bg-transparent p-2  rounded-3">
                                <nav style={{bsbreadcrumbdivider: 'url(&#34;"data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="8" height="8"%3E%3Cpath d="M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z" fill="currentColor"/%3E%3C/svg%3E&#34")'}} aria-label="breadcrumb">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item bg-transparent"><a href="dashboard.html" className="text-decoration-none text-info">Dashboard</a></li>
                                        <li className="breadcrumb-item text-muted text-capitalize bg-transparent" aria-current="page">follow up</li>
                                    </ol>
                                </nav>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row my-2">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-2 px-3">
                            <div className="bg-white p-2  rounded-3 shadow-sm">
                                <div className="row px-5 py-3">
                                    <div className="col-12">
                                        <div className="d-flex justify-content-between">
                                            <div className="bg-transparent">
                                                
                                            </div>
                                            <div className="bg-white">
                                                <button className="btn btn-sm  text-white" id="icueCreateFollowUpBtn" data-bs-toggle="modal" data-bs-target="#icueCreateFollowUpModal" style={{backgroundColor:"#3A3285"}}><i className="bi bi-plus-lg"></i> Create Follow Up</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{lineHeight:"-50px"}}><hr /></div>
                                <form id="icueFollowInfoForm" onSubmit={handleEditFormSubmit}>
                                    <div className="row  px-5 pt-3 pb-5">
                                        <table className="table table-striped table-hover" id="icueFollowUpTable">
                                            <thead>
                                                <tr className="text-uppercase border-bottom" style={{border:"0"}}>
                                                    <th className="py-3 border-0">follow up date</th>
                                                    <th className="text-center py-3 border-0" >description</th>
                                                    <th className="text-center py-3 border-0" >follow up</th>
                                                    <th className="text-center py-3 border-0">action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-capitalize"style={{fontFamily:"Calibri", fontWeight:"normal"}}>
                                                {/* <tr style={{border:"0"}}>
                                                    <td>15-feb-2022</td>
                                                    <td>call for policy renewal</td>
                                                    <td className="text-center">
                                                        <button type="button" className="btn btn-sm btn-toggle" data-toggle="button" aria-pressed="false" autocomplete="off" id="toggBtn_1"><div className="handle"></div></button>
                                                    </td>
                                                    <td className="text-center">
                                                        <button type="button" className="btn btn-sm btn-transparent" data-bs-toggle="modal" data-bs-target="#icueEditFollowUpModal"><i className="bi bi-pencil"></i></button>
                                                        <button type="button" className="btn btn-sm btn-transparent icueDelBtnRow"><i className="bi bi-trash"></i></button>
                                                    </td>
                                                </tr>
                                                <tr style={{border:"0"}}>
                                                    <td>26-aug-2021</td>
                                                    <td>call for policy renewal</td>
                                                    <td className="text-center">
                                                        <button type="button" className="btn btn-sm btn-toggle" data-toggle="button" aria-pressed="false" autocomplete="off" id="toggBtn_2"><div className="handle"></div></button>
                                                    </td>
                                                    <td className="text-center">
                                                        <button type="button" className="btn btn-sm btn-transparent" data-bs-toggle="modal" data-bs-target="#icueEditFollowUpModal"><i className="bi bi-pencil"></i></button>
                                                        <button type="button" className="btn btn-sm btn-transparent icueDelBtnRow"><i className="bi bi-trash"></i></button>
                                                    </td>
                                                </tr> */}
                                                {contacts.map((contact) => (
              <Fragment>
                {editContactId === contact.id ? (
                  <EditableRow
                    editFormData={editFormData}
                    handleEditFormChange={handleEditFormChange}
                    handleCancelClick={handleCancelClick}
                  />
                ) : (
                  <ReadOnlyRow
                    contact={contact}
                    handleEditClick={handleEditClick}
                    handleDeleteClick={handleDeleteClick}
                  />
                )}
              </Fragment>
            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </form>
                            </div>
                            </div>
                        </div>            
                     

<div className="modal fade " id="icueCreateFollowUpModal" tabindex="-1" aria-labelledby="icueCreateFollowUpModalLabel" aria-hidden="true">
    {/* <!-- <div className="modal-dialog modal-dialog-centered"> --> */}
    <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header py-1 shadow-sm">
                <h5 className="modal-title text-capitalize" id="editRfqDetModalLabel">Create Follow Up</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{backgroundColor: "#edf5fb"}}>
                <form className="">
                    <div className="row">
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 mx-auto">
                            <div className="form-group pb-2">
                                <input className="form-control" name="Date"  onChange={handleAddFormChange} type="Date" style={{width:"100%"}} />
                            </div>
                        </div>
                        {/* <div className="col-lg-9 col-md-9 col-sm-12 col-12 mx-auto">
                            <div className="form-group pb-2">
                                <input className="form-control" type="text" name="icueFollowUpTitle" placeholder="Follow up title"   />
                            </div>
                        </div> */}
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 mx-auto">
                            <div className="form-group pb-2">
                                <textarea className="form-control" id="icueRfqDetailsDesc" name="description"  onChange={handleAddFormChange} rows="3" placeholder="Description of follow up" style={{width:"100%"}}></textarea>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 py-3 mx-auto">
                            <div className="d-grid gap-2">
                                <button type="submit" data-bs-dismiss="modal" onClick={handleAddFormSubmit} className="btn text-white " style={{backgroundColor:"#3A3285"}}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

                    
                </main>
            </div>
        </div>
   
        </div>

         
    
    
    </div>)
}
export default Followup;